import React, { useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import AttachLink from '../attachLink'

const ExtensiveCarouselSimpleCardModal = ({
  cancelCardModal,
  slideObj,
  addCallback,
  updateCallback,
  isEdit,
  categoryList,
}) => {
  const { loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [imageS3key, setImageS3key] = useState('')
  const [heading, setHeading] = useState('')
  const [link, setLink] = useState({
    type: '',
    data: {},
  })

  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mainImg',
        width: 307,
        height: 172,
        divwidth: '8.87rem',
        divheight: '5.6rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        titleDisabled: true,
        uploadIconflexRow: true,
        uploadIconsize: '7px',
        btnMarginTop: '5px',
      },
    ]

    if (isEdit) {
      setHeading(slideObj.heading)
      setImageS3key(slideObj.image_s3key)
      setLink(slideObj.link)
      imgData[0]['assetId'] = slideObj.image_s3key
      imgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        slideObj.image_s3key,
      )
    }

    setImageData(imgData)
  }, [])

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let dataObj = {
      image_s3key: imageS3key,
      heading: heading,
      link: link,
    }

    isEdit ? updateCallback(dataObj) : addCallback(dataObj)

    cancelCardModal()
  }

  return (
    <CModal size="lg" className="category-card-modal" alignment="center" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalBody className="">
        <div className="py-3 px-4 d-flex justify-content-between">
          <div style={{ width: '20%' }} className="">
            <div className="">
              <ImageUploader data={imageData} />
              <span className="mt-2 " style={{ fontSize: '10.5px', color: '#707070' }}>
                Dimension: 307px X 172px Maximum size: 4 MB
              </span>
            </div>
            <div className="message-text error-message">
              <p>{errorData.imageS3key}</p>
            </div>
          </div>
          <div style={{ width: '75%' }} className={`d-flex flex-column justify-content-start `}>
            <div>
              <h6 style={{ fontSize: '12px' }}>Heading</h6>
              <CustomDescriptionBox
                limit={35}
                rows={1}
                value={heading}
                onChange={(value) => setHeading(value)}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
            <div>
              <AttachLink
                linkData={link}
                id={'link1'}
                categoryData={categoryList}
                setLinkData={(value) => {
                  clearError('link')
                  setLink(value)
                }}
              />
            </div>
          </div>
        </div>
        <div className="py-2 px-4 d-flex justify-content-end">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={() => {
              cancelCardModal()
            }}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={handleSave}
          >
            Save
          </CButton>
        </div>
      </CModalBody>
    </CModal>
  )
}

export default ExtensiveCarouselSimpleCardModal
